import React, {memo} from 'react'

import ListGood from '../ListGood'
import CardGood from '../CardGood/index'
import TableGood from '../TableGood'

const componentsByViewType = {
  list: ListGood,
  cards: CardGood,
  table: TableGood,
}

const Good = ({viewType, ...params}) => {
  const Component = componentsByViewType[viewType]
  return <Component {...params}/>
}

export default memo(Good, (prevProps, nextProps) =>
  prevProps.viewType === nextProps.viewType
  && prevProps.activeCatalogType === nextProps.activeCatalogType
  && prevProps.activeCategory === nextProps.activeCategory
  && prevProps.quantityInCart === nextProps.quantityInCart
  && prevProps.good.id === nextProps.good.id
  && prevProps.good.version === nextProps.good.version
)
